import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "~/App";
import { ThemeProvider } from "~/contexts/ThemeContextProvider";

import "~/index.scss";

const rootElement = document.getElementById("root");

if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </StrictMode>,
  );
}
